/* @luxottica/virtual-mirror v7.4.0 */
function ___$insertStyle(css) {
    if (!css || typeof window === 'undefined') {
        return;
    }
    const style = document.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    document.head.appendChild(style);
    return css;
}

export { PrivacyLocalizationKey } from '@luxottica/bipa-manager';
export { GlassesEnvironment } from '@luxottica/vm-glasses';
export { U as UpcMissingError, r as UpcSupportedError, o as VirtualMirror, q as VirtualMirrorCatalogue, n as VmAbstractError, n as VtoError, p as performanceEvents } from './virtual-mirror-VirtualMirror-c63eaa3e.js';
import '@luxottica/vm-remotelog';
import 'redux';
import 'redux-actions';
import 'react-dom';
import '@luxottica/vto-microservices';
import 'pubsub-js';
import '@luxottica/vm-devicedetection';
import 'current-device';
import '@luxottica/vm-eventbus';
import '@luxottica/vm-webcam';
//# sourceMappingURL=virtual-mirror.js.map
